// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1PenG","modalFooterButton":"ModalNotes_modalFooterButton__3G947"};